import moment from "moment";
import _ from "lodash";
import dayjs from "dayjs";

export const formValidation = (data) => {
  let inputAvisDate = data.get("textField-datePicker-avisdate")
    ? dayjs(data.get("textField-datePicker-avisdate")).format(
        "YYYY-MM-DDTHH:mm"
      )
    : "";
  let inputEstimatedArrivalDate = data.get(
    "textField-datePicker-estimatedArrivalDate"
  )
    ? dayjs(data.get("textField-datePicker-estimatedArrivalDate")).format(
        "YYYY-MM-DD"
      )
    : "";
  let inputTruckPlate = data.get("truckplate");
  let inputTrailorPlate = data.get("trailorplate");
  let inputDriverName = data.get("driverName");
  let platePattern = /[A-Za-z0-9 ]{2,15}/;
  let namePattern = /[A-Za-z ]{2,50}/;

  let inputBlNumber = data.get("blNumber");
  let inputContainerNumber = data.get("containerNumber");
  let inputSailDate = data.get("sailDate")
    ? dayjs(data.get("sailDate")).format("YYYY-MM-DD")
    : "";
  let inputEta = data.get("eta")
    ? dayjs(data.get("eta")).format("YYYY-MM-DD")
    : "";
  let blNumberPattern = /^.{8,16}$/;
  let containerNumberPattern = /^[A-Za-z0-9]{11}$/;
  let portOfExit = data.get("portOfExit");
  let portOfEntry = data.get("portOfEntry");

  const validationMap = new Map();

  if (null != inputAvisDate && !_.isEqual(inputAvisDate, "")) {
    if (moment(inputAvisDate, "YYYY/MM/DD HH:mm").isBefore(moment())) {
      validationMap.set("avisDateError", true);
    } else {
      validationMap.set("avisDateError", false);
    }
  }

  if (
    null != inputEstimatedArrivalDate &&
    !_.isEqual(inputEstimatedArrivalDate, "")
  ) {
    if (
      moment(inputEstimatedArrivalDate, "YYYY/MM/DD").isBefore(
        moment(inputAvisDate, "YYYY/MM/DD")
      )
    ) {
      validationMap.set("estimatedArrivalDateError", true);
    } else {
      validationMap.set("estimatedArrivalDateError", false);
    }
  }

  if (null != inputTruckPlate && !_.isEqual(inputTruckPlate, "")) {
    if (!platePattern.test(inputTruckPlate)) {
      validationMap.set("truckPlateError", true);
    } else {
      validationMap.set("truckPlateError", false);
    }
  }

  if (null != inputTrailorPlate && !_.isEqual(inputTrailorPlate, "")) {
    if (!platePattern.test(inputTrailorPlate)) {
      validationMap.set("trailorPlateError", true);
    } else {
      validationMap.set("trailorPlateError", false);
    }
  }

  if (null != inputDriverName && !_.isEqual(inputDriverName, "")) {
    if (!namePattern.test(inputDriverName)) {
      validationMap.set("driverNameError", true);
    } else {
      validationMap.set("driverNameError", false);
    }
  }
  if (
    (portOfExit != null && !_.isEqual(portOfExit, "")) ||
    (portOfEntry != null && !_.isEqual(portOfEntry, ""))
  ) {
    if (portOfExit === portOfEntry) {
      validationMap.set("portError", true);
    } else {
      validationMap.set("portError", false);
    }
  }

  if (null != inputBlNumber && !_.isEqual(inputBlNumber, "")) {
    if (!blNumberPattern.test(inputBlNumber)) {
      validationMap.set("blNumberError", true);
    } else {
      validationMap.set("blNumberError", false);
    }
  }
  if (null != inputContainerNumber && !_.isEqual(inputContainerNumber, "")) {
    if (!containerNumberPattern.test(inputContainerNumber)) {
      validationMap.set("containerNumberError", true);
    } else {
      validationMap.set("containerNumberError", false);
    }
  }

  if (null != inputSailDate && !_.isEqual(inputSailDate, "")) {
    const minSailDate = dayjs().subtract(60, "day").format("YYYY-MM-DD");
    const maxSailDate = dayjs().add(60, "day").format("YYYY-MM-DD");
    if (
      moment(inputSailDate, "YYYY/MM/DD").isBefore(minSailDate) ||
      moment(inputSailDate, "YYYY/MM/DD").isAfter(maxSailDate)
    ) {
      validationMap.set("sailDateError", true);
    } else {
      validationMap.set("sailDateError", false);
    }
  }

  if (null != inputEta && !_.isEqual(inputEta, "")) {
    const minEtaDate = dayjs().subtract(60, "day").format("YYYY-MM-DD");
    const maxEtaDate = dayjs().add(180, "day").format("YYYY-MM-DD");
    if (
      moment(inputEta, "YYYY-MM-DD").isBefore(inputSailDate) ||
      moment(inputEta, "YYYY/MM/DD").isBefore(minEtaDate) ||
      moment(inputEta, "YYYY/MM/DD").isAfter(maxEtaDate)
    ) {
      validationMap.set("etaError", true);
    } else {
      validationMap.set("etaError", false);
    }
  }

  return validationMap;
};
